module.exports = __webpack_public_path__ + "img/组5247@2x.0e8805ce.png";